<div class="image-preview">
	<div class="header">
		{{ title }}
	</div>
	<img src="{{ image }}" />
</div>
